angular.module("app").directive("designerUseColorAcrossSeasons", () => {
  let link = (scope) => {

  };

  return {
    restrict: "E",
    templateUrl: "app/directives/dbDesignerUseColorAcrossSeasons/dbDesignerUseColorAcrossSeasonsView.html",
    link: link,
    scope: {
      data: "="
    }
  };
});
